import script from "./FigurePay.vue?vue&type=script&lang=ts&setup=true"
export * from "./FigurePay.vue?vue&type=script&lang=ts&setup=true"

import "./FigurePay.vue?vue&type=style&index=0&id=9e479ede&lang=scss"
import "./FigurePay.vue?vue&type=style&index=1&id=9e479ede&lang=scss&scoped=true"
import "./FigurePay.vue?vue&type=style&index=2&id=9e479ede&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e479ede"]])

export default __exports__